// extracted by mini-css-extract-plugin
export var serviceImage = "service-module--serviceImage--oYEIP";
export var serviceSection = "service-module--serviceSection--XOgab";
export var test = "service-module--test--1V8QI";